module.exports = __webpack_public_path__ + "static/img/logo-index.f6f73de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo-index.png
// module id = 561
// module chunks = 313